import {ErrorHandler, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DipRegistrationInitializerService} from './services/dip-registration-initializer.service';
import {TranslateModule} from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {DipRegistrationContextGuardService} from './services/guards/dip-registration-context-guard.service';
import {DipRegistrationService} from '../dip-registration.service';
import {DipRegistrationRequestHeaderInterceptorService} from './services/interceptors/dip-registration-request-header-interceptor.service';
import {DipRegistrationFullDateComponent} from './components/dip-registration-full-date/dip-registration-full-date.component';
import {ReactiveFormsModule} from '@angular/forms';
import {DipRegistrationCloseGuardService} from './services/guards/dip-registration-close-guard.service';
import {DipRegistrationErrorsHandler} from '../dip-registration-error/dip-registration-errors.handler';
import {DipRegistrationConfirmService} from './services/dip-registration-confirm.service';
import {DipRegistrationConsoleLoggerService} from './services/logger/dip-registration-console-logger.service';
import {DipRegistrationLoggerService} from './services/logger/dip-registration-logger.service';
import {DipRegistrationNavigationService} from './services/dip-registration-navigation.service';
import {DipRegistrationRestartGuardService} from './services/guards/dip-registration-restart-guard.service';
import {DipRegistrationAuthTranslatePipe} from './services/dip-registration-auth-translate.pipe';
import {DipRegistrationContextService} from './services/dip-registration-context.service';
import {DipRegistrationAlertStore} from './services/alert/dip-registration-alert-store.service';
import {CookieService} from 'ngx-cookie-service';
import { DiprsSpaLoggerService } from './services/logger/diprs-spa-logger.service';
import { DipRegistrationCustomerIdentityService } from './services/dip-registration-customer-identity.service';
import {WebMetricStore} from './services/stores/dip-web-metric-store.service';

@NgModule({ declarations: [
        DipRegistrationFullDateComponent,
        DipRegistrationAuthTranslatePipe
        ],
    exports: [
        TranslateModule,
        DipRegistrationFullDateComponent,
        ReactiveFormsModule,
        DipRegistrationAuthTranslatePipe
        ],
    imports: [
        CommonModule,
        TranslateModule.forRoot(),
        ReactiveFormsModule,
        FormsModule
        ],
    providers: [
        DipRegistrationInitializerService,
        CookieService,
        DipRegistrationNavigationService,
        DipRegistrationConsoleLoggerService,
        DipRegistrationContextGuardService,
        DipRegistrationCloseGuardService,
        DipRegistrationRestartGuardService,
        DipRegistrationService,
        DipRegistrationConfirmService,
        DipRegistrationContextService,
        DipRegistrationAlertStore,
        WebMetricStore,
        DipRegistrationErrorsHandler,
        DiprsSpaLoggerService,
        DipRegistrationCustomerIdentityService,
        { provide: DipRegistrationLoggerService, useClass: DipRegistrationConsoleLoggerService },
        { provide: ErrorHandler, useClass: DipRegistrationErrorsHandler },
        { provide: HTTP_INTERCEPTORS, useClass: DipRegistrationRequestHeaderInterceptorService, multi: true }, provideHttpClient(withInterceptorsFromDi())] })
export class DipRegistrationCoreModule {
}
